import Banner from 'components/Banner';
import GradientText from 'components/GradientText';
import NewsCards from 'components/NewsCards';
import TagsFilter from 'components/TagsFilter';
import './styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBlog, fetchPostsForNews, selectBlogPage, selectPostForNews } from 'store/slices/BlogSlice';
import { useEffect } from 'react';
import React from 'react';
import ButtonShowMore from 'components/Button/ButtonShowMore';

const News = () => {
    const dispatch = useDispatch();
    const [selectedTag, setSelectedTag] = React.useState(undefined);
    const [page, setPage] = React.useState(1);

    const { title, description, tags, title_background, show_all_button, show_more_button, fs_button_text } =
        useSelector(selectBlogPage);

    const { data, next } = useSelector(selectPostForNews);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchBlog());
        setSelectedTag(show_all_button);
    }, [dispatch, show_all_button]);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchPostsForNews({ tag: selectedTag === show_all_button ? null : selectedTag, page }));
    }, [dispatch, selectedTag, page, show_all_button]);

    const handleClick = name => {
        setPage(1);
        setSelectedTag(name);
    };
    const handleShowMore = () => setPage(page + 1);

    return (
        <>
            <Banner title={title} image={title_background} buttonText={fs_button_text} />

            <section className="container">
                <div className="inner-container">
                    <div className="news-heading">
                        <GradientText size="small">
                            <div className="max-width-760">
                                <span dangerouslySetInnerHTML={{ __html: description }} />
                            </div>
                        </GradientText>
                        <TagsFilter
                            showAllName={show_all_button}
                            tags={tags}
                            selectedTag={selectedTag}
                            onClick={handleClick}
                        />
                    </div>
                    <NewsCards posts={data} />
                    <ButtonShowMore next={next} text={show_more_button} onClick={handleShowMore} />
                </div>
            </section>
        </>
    );
};

export default News;
